const path = 'redux/mapping';

export const SET_HAS_RELATED_CONTACTS = `${path}/SET_HAS_RELATED_CONTACTS`;
export const SET_CONTACT_ROLE_CATEGORY = `${path}/SET_CONTACT_ROLE_CATEGORY`;
export const SET_CONTACT_ROLE_SEGMENT = `${path}/SET_CONTACT_ROLE_SEGMENT`;
export const SET_CONTACT_ROLE = `${path}/SET_CONTACT_ROLE`;
export const RESET_RELATED_CONTACTS = `${path}/RESET_RELATED_CONTACTS`;
